import { Component, inject, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { SourcePointService } from '@zero/shared/util-source-point';
import { AuthService } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';

@Component({
  selector: 'onboarding-footer',
  imports: [TranslocoPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  public hideLogout = input<boolean>();

  public readonly authService = inject(AuthService);
  public readonly sourcePoint = inject(SourcePointService);
  public currentYear: number = new Date().getFullYear();
  public readonly externalLinks = environment.externalLinks;
}
